<template>
    <div class="form-horizontal">
        <div class="form-group">
            <label for="user-options" class="col-xs-12 col-md-4 control-label">{{ $t('components.subscription_type.type') }}</label>
            <div class="col-xs-12 col-md-8">
                <select class="form-control" id="user-options" v-model="subscription_type.category">
                    <option v-for="subscriptionType in subscriptionTypeOptions" :key="subscriptionType.value"
                            :value="subscriptionType.value">{{subscriptionType.name}}</option>
                </select>
            </div>
        </div>
        <div class="form-group">
            <label for="subscription_type_name" class="col-xs-12 col-md-4 control-label">{{ $t('common.first_name') }}</label>
            <div class="col-xs-12 col-md-8">
                <input class="form-control" type="text" v-model="subscription_type.name" id="subscription_type_name" name="subscription_type_name" :placeholder="$t('components.subscription_type.example')">
            </div>
        </div>
        <div class="form-group" v-if="isNormal">
            <label for="subscription_type_unlimited_renewable" class="col-xs-12 col-md-4 control-label">{{ $t('components.subscription_type.renew_unlimited') }}</label>
            <div class="col-xs-12 col-md-8">
                <select class="form-control" v-model="subscription_type.unlimited_renewable" id="subscription_type_unlimited_renewable" name="subscription_type_unlimited_renewable">
                    <option :value="true">{{ $t('common.yes') }}</option>
                    <option :value="false">{{ $t('common.no') }}</option>
                </select>
            </div>
        </div>
        <div class="form-group" v-if="!subscription_type.unlimited_renewable">
            <label for="subscription_type_months_renewable" class="col-xs-12 col-md-4 control-label">{{ $t('components.subscription_type.how_many_renew') }}</label>
            <div class="col-xs-12 col-md-8">
                <select class="form-control" v-model="subscription_type.months_renewable" id="subscription_type_months_renewable" name="subscription_type_months_renewable">
                    <option :value="0">{{ $t('components.subscription_type.not_renew') }}</option>
                    <option :value="1">{{ $t('components.subscription_type.renew_n_times', {n: 1, m: 2}) }}</option>
                    <option :value="2">{{ $t('components.subscription_type.renew_n_times', {n: 2, m: 3}) }}</option>
                    <option :value="3">{{ $t('components.subscription_type.renew_n_times', {n: 3, m: 4}) }}</option>
                    <option :value="4">{{ $t('components.subscription_type.renew_n_times', {n: 4, m: 5}) }}</option>
                </select>
            </div>
        </div>
        <div class="form-group">
            <label for="subscription_type_unlimited_redeemable" class="col-xs-12 col-md-4 control-label">{{ $t('components.subscription_type.redeemable') }}</label>
            <div class="col-xs-12 col-md-8">
                <select class="form-control" id="subscription_type_unlimited_redeemable" v-model="subscription_type.unlimited_redeemable">
                    <option :value="false">{{ $t('components.subscription_type.redeemable_number') }}</option>
                    <option :value="true">{{ $t('components.subscription_type.redeemable_unlimited') }}</option>
                </select>
            </div>
        </div>
        <div class="form-group" v-if="!subscription_type.unlimited_redeemable">
            <label for="subscription_type_appointments_redeemable" class="col-xs-12 col-md-4 control-label">{{ $t('components.subscription_type.included_appointments') }}</label>
            <div class="col-xs-12 col-md-8">
                <div style="width:60px;">
                    <input class="form-control" type="text" v-model="subscription_type.appointments_redeemable" id="subscription_type_appointments_redeemable" name="subscription_type_appointments_redeemable" value="4">
                </div>
            </div>
        </div>
        <div class="form-group"  v-if="isCarnet">
            <label for="subscription_type_valid_for_days" class="col-xs-12 col-md-4 control-label">{{ $t('components.subscription_type.validity') }}</label>
            <div class="col-xs-12 col-md-8">
                <div class="input-group" style="width:140px;">
                    <input class="form-control" type="number" v-model="subscription_type.valid_for_days" id="subscription_type_valid_for_days" name="subscription_type_valid_for_days"  step="1">
                    <div class="input-group-addon">{{ $t('unit.days') }}</div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="subscription_type_price" class="col-xs-12 col-md-4 control-label">{{ $t('common.price') }}</label>
            <div class="col-xs-12 col-md-8">
                <div class="input-group" style="width:140px;">
                    <input class="form-control" type="number" v-model="subscription_type.price" id="subscription_type_price" name="subscription_type_price"  step="0.01">
                    <div class="input-group-addon">{{default_currency}}</div>
                </div>
                <div v-if="subscription_type.price">
                    <p class="help-block">{{ $t('components.rate.gross_price', {gross_price: grossPrice, gross_price_currency: getCurrencySymbolFromString(subscription_type.price_currency)}) }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        SUBSCRIPTION_CATEGORY,
        SUBSCRIPTION_CATEGORY_OPTIONS
    } from "../../common/constants";
    import {Utils} from "@/common/utils";

    export default {
        name: "SubscriptionTypeForm",
        props: {
            subscriptionTypeProp: {
                type: Object,
                required: true
            }
        },
        data: () => {
            return {
                subscriptionTypeOptions: SUBSCRIPTION_CATEGORY_OPTIONS(),
                subscription_type: {
                    name: "",
                    valid_for_days: 30,
                    category: SUBSCRIPTION_CATEGORY.NORMAL,
                    price: 0,
                    unlimited_renewable: true,
                    months_renewable: 0,
                    unlimited_redeemable: false,
                    appointments_redeemable: 1,
                    valid_for_rates: [],
                },
                default_currency: ""
            }
        },

        computed: {
            grossPrice() {
                return Utils.getGrossPriceOnlineWithCreditCard(this.subscription_type.price)
            },
            isNormal: function () {
                return this.subscription_type.category === SUBSCRIPTION_CATEGORY.NORMAL
            },
            isCarnet: function () {
                return this.subscription_type.category === SUBSCRIPTION_CATEGORY.CARNET
            }
        },
        mounted: function () {
            this.subscription_type = this.subscriptionTypeProp;
            this.default_currency = Utils.getCompanyCurrency();
        },
        watch: {
            subscriptionTypeProp: function(newVal) {
                this.subscription_type = newVal;
            },
            subscription_type: {
                handler(newVal) {
                    this.$emit('change', newVal)
                },
                deep: true,
            }
        },
        methods: {
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency)
            }
        }
    }
</script>
